<template>
    <div class="property-details-attribution">
        <b-row>
            <b-col
                    v-if="getLexicon"
                    cols="12"
                    lg="9"
                    class="d-flex align-items-center"
            >
                <div
                        v-html="getLexicon"
                />
            </b-col>
            <b-col
                    v-if="getAssetUrl"
                    cols="12"
                    lg="3"
                    class="d-flex align-items-center justify-content-end logo-container"
            >
                <b-img
                        :src="getAssetUrl"
                        class="w-100"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import './PropertyDetailsAttribution.scss';
    import {mapGetters} from "vuex";
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";

    export default {
        name: 'PropertyDetailsAttribution',
        props: {
            propertyAppResource: {
                type: AppResource,
                required: true,
            },
            mlsCompliance: {
                type: [Object, Boolean],
                required: true,
            },
        },
        mixins: [
            ShowNotificationMixin,
        ],
        computed: {
            ...mapGetters({
                project: 'getCurrentWorkspace',
            }),
            getLexicon() {
                return this.mlsCompliance?.data?.data?.details?.attribution?.lexicon;
            },
            getAssetUrl() {
                return this.mlsCompliance?.data?.data?.details?.attribution?.asset?.url;
            }
        }
    };
</script>
